window.jobLogoGrid = () => {
    return {
        initialCount: 9,
        loadMoreCount: 9,
        currentCount: 9,
        
        // Check if there are more logos to load
        get canLoadMore() {
            return this.currentCount < document.querySelectorAll('.Job__Logo__Grid-item').length;
        },
        
        // Load more logos by increasing the count
        loadMore() {
            this.currentCount += this.loadMoreCount;
        }
    }
}
